<template>
  <v-row dense>
    <v-col
      cols="12"
      class="text-h5"
    >
      Content Pages
    </v-col>
    <v-col cols="12">
      <v-btn
        v-for="filter in filters"
        :key="filter.id"
        color="black"
        class="mr-2"
        :text="filterId != filter.id"
        @click="filterId = filter.id"
      >
        {{ filter.name }}
      </v-btn>
    </v-col>
    <v-col cols="12">
      <Types v-if="filterId == 'types'" />
      <NeedsGeneration
        v-else-if="filterId == 'needs_generation'"
        ref="needsGen"
      />
      <List
        v-else
        :type="filterId"
        :loading="loading"
        @reload="loadData"
      />
    </v-col>
  </v-row>
</template>

<script>
import List from '@/components/content/pages/List';
import Types from '@/components/content/pages/Types';
import NeedsGeneration from '@/components/content/pages/needsgeneration/Index';
import { mapGetters } from 'vuex/dist/vuex.common.js';
export default {
  components: { List, Types, NeedsGeneration },
  data() {
    return {
      loading: false,
      saving: false,
      filterId: 'needs_attention'
    };
  },

  computed: {
    filters() {
      let list = [
        { id: 'needs_attention', name: 'Needs Attention' },
        { id: 'needs_generation', name: 'Needs Generation' }
      ];

      list = list.concat(this.types.map((x) => ({ id: x.id.toString(), name: x.name })));

      list.push({ id: 'types', name: 'Types' });
      return list;
    },
    ...mapGetters({
      types: 'lookup/content_page_types'
    })
  },

  async mounted() {
    // A deep link may set the starting tab, e.g. /content/pages?tab=needs_generation.
    if (this.$route.query.tab) {
      this.filterId = this.$route.query.tab;
    }
    this.loadData();
    // Single owner of the "a page was created" refresh, so the two lists don't clobber each other's
    // bus handler. Reloads the content pages AND (when it's the active tab) the needs-generation list.
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.PAGE_ADD_SAVED);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.PAGE_ADD_SAVED, () => this.reloadAll());
  },

  methods: {
    loadData() {
      this.loading = true;

      Promise.all([this.$store.dispatch('content/getPages')])
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reloadAll() {
      this.loadData();
      // The needs-generation list holds its candidates locally, so refresh it directly when it's mounted.
      if (this.$refs.needsGen) {
        this.$refs.needsGen.loadData();
      }
    }
  }
};
</script>
